export default "__VITE_ASSET__d8a20841__"